import LowRiskGaugeImage from "src/modules/3rd-party-management/assets/images/low-risk-gauge-image.png";
import MediumRiskGaugeImage from "src/modules/3rd-party-management/assets/images/medium-risk-gauge-image.png";
import HighRiskGaugeImage from "src/modules/3rd-party-management/assets/images/high-risk-gauge-image.png";

export const PRIVACY_RISK_GAUGE = {
    low: {
        image: LowRiskGaugeImage,
        label: "Low Risk",
        color: "#1CBB8C"
    },
    high: {
        image: HighRiskGaugeImage,
        label: "High Risk",
        color: "#EB5757"
    },
    not_assessed: {
        image: MediumRiskGaugeImage,
        label: "Not Assessed",
        color: "#828282"
    }
};

export const getPrivacyRiskGauge = (riskLevel) => {
    return PRIVACY_RISK_GAUGE[riskLevel] || PRIVACY_RISK_GAUGE.not_assessed;
};
